import { __ } from '@oat-sa-private/ui-core';

__("Missing comma(s), there should be exactly %d column at row \"%s\"");
__("The uploaded file contains duplicate usernames. Please remove duplicate usernames and try again.");
__('The scoring task ID:%s is already scored and submitted.');
